import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(
      () => import("views/auth-views/authentication/login"),
    ),
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(
      () => import("views/auth-views/authentication/forgot-password"),
    ),
  },
];

export const protectedRoutes = [
  {
    key: "dashboard",
    path: `${APP_PREFIX_PATH}`,
    component: React.lazy(() => import("views/app-views/dashboard")),
  },
  // Change Password
  {
    key: "change-password",
    path: `${APP_PREFIX_PATH}/change-password`,
    component: React.lazy(() => import("views/app-views/change-password")),
  },
  // Surat Keluar
  {
    key: "surat-keluar",
    path: `${APP_PREFIX_PATH}/surat-keluar`,
    component: React.lazy(() => import("views/app-views/surat-keluar")),
  },
  {
    key: "surat-keluar-detail",
    path: `${APP_PREFIX_PATH}/surat-keluar/detail/:id`,
    component: React.lazy(() => import("views/app-views/surat-keluar/detail")),
  },
  {
    key: "surat-keluar-form",
    path: `${APP_PREFIX_PATH}/surat-keluar/form/:id?`,
    component: React.lazy(() => import("views/app-views/surat-keluar/form")),
  },
  // Surat Masuk
  {
    key: "surat-masuk",
    path: `${APP_PREFIX_PATH}/surat-masuk`,
    component: React.lazy(() => import("views/app-views/surat-masuk")),
  },
  {
    key: "surat-masuk-detail",
    path: `${APP_PREFIX_PATH}/surat-masuk/detail/:id`,
    component: React.lazy(() => import("views/app-views/surat-masuk/detail")),
  },
  {
    key: "surat-masuk-form",
    path: `${APP_PREFIX_PATH}/surat-masuk/form/:id?`,
    component: React.lazy(() => import("views/app-views/surat-masuk/form")),
  },
  // User
  {
    key: "user",
    path: `${APP_PREFIX_PATH}/user`,
    component: React.lazy(() => import("views/app-views/user")),
  },
  {
    key: "user-detail",
    path: `${APP_PREFIX_PATH}/user/detail/:id`,
    component: React.lazy(() => import("views/app-views/user/detail")),
  },
  {
    key: "user-form",
    path: `${APP_PREFIX_PATH}/user/form/:id?`,
    component: React.lazy(() => import("views/app-views/user/form")),
  },
  // Manajemen Satker
  {
    key: "master-data-satker",
    path: `${APP_PREFIX_PATH}/master-data/satker`,
    component: React.lazy(() => import("views/app-views/master-data/satker")),
  },
  {
    key: "master-data-satker-form",
    path: `${APP_PREFIX_PATH}/master-data/satker/form/:id?`,
    component: React.lazy(
      () => import("views/app-views/master-data/satker/form"),
    ),
  },
  // Kode Arsip
  {
    key: "master-data-kode-arsip",
    path: `${APP_PREFIX_PATH}/master-data/kode-arsip`,
    component: React.lazy(
      () => import("views/app-views/master-data/kode-arsip"),
    ),
  },
  {
    key: "master-data-kode-arsip-form",
    path: `${APP_PREFIX_PATH}/master-data/kode-arsip/form/:id?`,
    component: React.lazy(
      () => import("views/app-views/master-data/kode-arsip/form"),
    ),
  },
  // Fasilitatif
  {
    key: "master-data-fasilitatif",
    path: `${APP_PREFIX_PATH}/master-data/fasilitatif`,
    component: React.lazy(
      () => import("views/app-views/master-data/fasilitatif"),
    ),
  },
  {
    key: "master-data-kode-arsip-form",
    path: `${APP_PREFIX_PATH}/master-data/fasilitatif/form/:id?`,
    component: React.lazy(
      () => import("views/app-views/master-data/fasilitatif/form"),
    ),
  },
  // Integrasi
  {
    key: "integrasi",
    path: `${APP_PREFIX_PATH}/integrasi`,
    component: React.lazy(() => import("views/app-views/integrasi")),
  },
  {
    key: "integrasi-detail",
    path: `${APP_PREFIX_PATH}/integrasi/detail/:id`,
    component: React.lazy(() => import("views/app-views/integrasi/detail")),
  },
  {
    key: "integrasi-form",
    path: `${APP_PREFIX_PATH}/integrasi/form/:id?`,
    component: React.lazy(() => import("views/app-views/integrasi/form")),
  },
  // Rekap
  {
    key: "rekap-fasilitatif",
    path: `${APP_PREFIX_PATH}/rekap/fasilitatif`,
    component: React.lazy(() => import("views/app-views/rekap/fasilitatif")),
  },
  {
    key: "rekap-kode-arsip",
    path: `${APP_PREFIX_PATH}/rekap/kode-arsip`,
    component: React.lazy(() => import("views/app-views/rekap/kode-arsip")),
  },
  {
    key: "rekap-pembuat",
    path: `${APP_PREFIX_PATH}/rekap/pembuat`,
    component: React.lazy(() => import("views/app-views/rekap/pembuat")),
  },
  {
    key: "error",
    path: `*`,
    component: React.lazy(() => import("views/auth-views/errors/error-page-1")),
    meta: {
      blankLayout: true,
    },
  },
];
